export const default_alert = (message: string) => {
  return alert(message)
}
